import { nanoid } from "nanoid";

export const generateUID = (prefix?: string): string => {
  return `${prefix ?? "id"}-${nanoid(8)}`;
};

export const uniqBy = <T>(items: T[], idField: keyof T | string): T[] => {
  const uniqItems: Record<string, T> = {};
  items.forEach((value) => (uniqItems[value[`${idField}`]] = value));
  return Object.values(uniqItems);
};
